import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from '@mantine/form'
import { Box, Button, Checkbox, Text, TextInput } from '@mantine/core'
import { IconPhone, IconShieldCheck } from '@tabler/icons-react'
import useVerificationCodeTimer from '../../hooks/useVerificationCodeTimer'
import { login } from '../../api/userService'
import { USER_TOKEN_KEY } from '../../constants/localStorageConstants'
import { Dialog } from 'antd-mobile'

export default function LoginForm() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const { label, startTimer, isActive } = useVerificationCodeTimer()

  const form = useForm({
    initialValues: {
      phone: '',
      smsCode: '',
      termsOfService: false,
    },
    validate: {
      phone: (value) => (value === '' ? '请输入手机号' : !/^1[3-9]\d{9}$/.test(value) ? '请输入正确的手机号' : null),
      smsCode: (value) => (value === '' ? '请输入验证码' : value.length !== 6 ? '请输入6位的验证码' : null),
    },
  })

  const agreeTermsOfService = () => {
    return (
      <>
        我已阅读并同意
        <span
          style={{ color: '#1e3a8a', cursor: 'pointer' }}
          onClick={(e) => {
            e.preventDefault()
            // eslint-disable-next-line no-restricted-globals
            open('/userAgreement.html', '_blank')
          }}
        >
          《用户协议》
        </span>
        和
        <span
          style={{ color: '#1e3a8a', cursor: 'pointer' }}
          onClick={(e) => {
            e.preventDefault()
            // eslint-disable-next-line no-restricted-globals
            open('/privacyPolicy.html', '_blank')
          }}
        >
          《隐私政策》
        </span>
      </>
    )
  }

  const userLogin = (values: any) => {
    setLoading(true)
    login(values)
      .then((res) => {
        localStorage.setItem(USER_TOKEN_KEY, res.tokenValue)
        navigate('/orders')
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <Box>
      <Box mb="xl" style={{ textAlign: 'center' }}>
        <Text size="28px" fw={700} style={{ color: '#1e3a8a', marginBottom: '8px' }}>
          欢迎登录
        </Text>
        <Text size="sm" c="dimmed">
          登录后可查看您的历史报告订单
        </Text>
      </Box>

      <form
        onSubmit={form.onSubmit((values) => {
          if (!values.termsOfService) {
            Dialog.confirm({
              content: agreeTermsOfService(),
              confirmText: '同意并登录',
              cancelText: '不同意',
              onConfirm: () => {
                form.setFieldValue('termsOfService', true)
                userLogin(values)
              },
            }).then()
          } else {
            userLogin(values)
          }
        })}
      >
        <TextInput
          size="lg"
          placeholder="请输入手机号"
          leftSection={<IconPhone size={18} />}
          styles={{
            input: {
              borderRadius: '12px',
              border: '1px solid #e5e7eb',
            },
          }}
          {...form.getInputProps('phone')}
        />
        <TextInput
          size="lg"
          mt="lg"
          maxLength={6}
          placeholder="请输入验证码"
          leftSection={<IconShieldCheck size={18} />}
          rightSectionWidth={110}
          styles={{
            input: {
              borderRadius: '12px',
              border: '1px solid #e5e7eb',
            },
          }}
          rightSection={
            <Button
              size="sm"
              variant="subtle"
              onClick={() => {
                const phone = form.values.phone
                const result = form.validateField('phone')
                if (result.hasError) {
                  return
                }
                startTimer({ phone: phone, type: 1 })
              }}
              disabled={isActive}
              style={{ color: '#1e3a8a' }}
            >
              {label}
            </Button>
          }
          {...form.getInputProps('smsCode')}
        />
        <Checkbox
          color="#1e3a8a"
          mt="lg"
          mb="xl"
          label={agreeTermsOfService()}
          {...form.getInputProps('termsOfService', { type: 'checkbox' })}
        />
        <Button
          loading={loading}
          type="submit"
          fullWidth
          size="lg"
          styles={{
            root: {
              backgroundColor: '#1e3a8a',
              borderRadius: '12px',
              height: '48px',
              fontSize: '16px',
              fontWeight: 600,
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: '#1e40af',
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 12px rgba(30, 58, 138, 0.3)',
              },
            },
          }}
        >
          登录
        </Button>
      </form>
    </Box>
  )
}
